module.exports = __webpack_public_path__ + "static/media/Sept24-F19.364efb4e.png";